var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"utm-table-container"},[_c('b-table',{staticClass:"table mt-3",attrs:{"items":_vm.items,"fields":_vm.fields,"sort-by":"utmCampaign","hover":"","striped":"","small":"","responsive":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }